"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTradeBasePriceType = exports.getTradeBasePriceType = exports.setTradeBasePriceType = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const trade_utils_lib_1 = require("trade_utils_lib");
const const_1 = require("./../../../../component/const");
const LocalStorageKey = "KEY_TRADE_BASE_PRICE_TYPE";
function setTradeBasePriceType(baseType) {
    return (0, trade_utils_lib_1.getTradeDependencyInstance)().getLocalStorage().setItem(LocalStorageKey, baseType);
}
exports.setTradeBasePriceType = setTradeBasePriceType;
function getTradeBasePriceType(defaultValue = const_1.DEFAULT_BASE_PRICE_TYPE) {
    return (0, trade_utils_lib_1.getTradeDependencyInstance)()
        .getLocalStorage()
        .getItem("KEY_TRADE_BASE_PRICE_TYPE")
        .then((value) => value || defaultValue);
}
exports.getTradeBasePriceType = getTradeBasePriceType;
const subject = new rxjs_1.BehaviorSubject(null);
function notifyChangePriceType(type) {
    subject.next(type);
}
/**获取交易相关的基本价格类型 */
function useTradeBasePriceType(isActive = true) {
    const [basePriceType, setBasePriceType] = (0, react_1.useState)(const_1.DEFAULT_BASE_PRICE_TYPE);
    (0, react_1.useEffect)(() => {
        getTradeBasePriceType().then(setBasePriceType);
    }, []);
    (0, react_1.useEffect)(() => {
        if (!isActive) {
            return;
        }
        const sub = subject.subscribe({
            next: (newValue) => {
                newValue && setBasePriceType(newValue);
            }
        });
        return () => {
            sub.unsubscribe();
        };
    }, [isActive]);
    const changePriceType = (0, react_1.useCallback)((type) => {
        setTradeBasePriceType(type);
        setBasePriceType(type);
        notifyChangePriceType(type);
    }, []);
    return {
        basePriceType,
        changePriceType,
    };
}
exports.useTradeBasePriceType = useTradeBasePriceType;
